module.exports = __webpack_public_path__ + "img/5_17.5a19d16b.png";